"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _reactRedux = require("react-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIBackButton = _interopRequireDefault(require("UIComponents/nav/UIBackButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _Constants = require("FileManagerCore/Constants");

var _Folders = require("FileManagerCore/actions/Folders");

var _Constants2 = require("../../Constants");

var _Folders2 = require("../../selectors/Folders");

var _Tiles = require("../../selectors/Tiles");

var _Tiles2 = require("../../utils/Tiles");

var _Actions = require("../../actions/Actions");

var _BrowseFolders = _interopRequireDefault(require("./BrowseFolders"));

var _FoldersAndFilesContainer = _interopRequireDefault(require("../../containers/browser/FoldersAndFilesContainer"));

var _SearchWithSuggestions = _interopRequireDefault(require("./SearchWithSuggestions"));

var _AddFolderButton = _interopRequireDefault(require("./AddFolderButton"));

var _EmptyFolder = _interopRequireDefault(require("./EmptyFolder"));

var _Files = require("FileManagerCore/selectors/Files");

var _Permissions = require("FileManagerCore/selectors/Permissions");

var _Panel = require("../../selectors/Panel");

var _network = require("../../utils/network");

var _Filter = require("../../selectors/Filter");

var _FileExtensionFilters = _interopRequireDefault(require("../../enums/FileExtensionFilters"));

var _FilterHintMessage = _interopRequireDefault(require("./FilterHintMessage"));

var _FolderBreadcrumbs = _interopRequireDefault(require("./FolderBreadcrumbs"));

var FolderPanel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FolderPanel, _Component);

  function FolderPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FolderPanel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FolderPanel).call(this, props));
    _this.handleLoadMoreRows = _this.handleLoadMoreRows.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FolderPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          selectedFolder = _this$props.selectedFolder,
          fetchFiles = _this$props.fetchFiles,
          type = _this$props.type,
          withPanelNavigator = _this$props.withPanelNavigator;

      if (!withPanelNavigator) {
        fetchFiles({
          folderId: selectedFolder.get('id'),
          initial: true,
          type: type
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          selectedFolder = _this$props2.selectedFolder,
          fetchFiles = _this$props2.fetchFiles,
          type = _this$props2.type;

      if (prevProps.selectedFolder !== selectedFolder) {
        fetchFiles({
          folderId: selectedFolder.get('id'),
          initial: true,
          type: type
        });
      }
    }
  }, {
    key: "handleLoadMoreRows",
    value: function handleLoadMoreRows() {
      var _this$props3 = this.props,
          status = _this$props3.status,
          files = _this$props3.files,
          selectedFolder = _this$props3.selectedFolder,
          fetchFiles = _this$props3.fetchFiles,
          type = _this$props3.type;

      if (status === _Constants.RequestStatus.PENDING) {
        return;
      }

      fetchFiles({
        offset: files.count(),
        folderId: selectedFolder.get('id'),
        type: type
      });
    }
  }, {
    key: "renderTiles",
    value: function renderTiles() {
      var _this$props4 = this.props,
          type = _this$props4.type,
          total = _this$props4.total,
          tiles = _this$props4.tiles,
          status = _this$props4.status,
          selectedFolder = _this$props4.selectedFolder,
          onAddFolder = _this$props4.onAddFolder,
          onInsert = _this$props4.onInsert,
          folders = _this$props4.folders,
          isReadOnly = _this$props4.isReadOnly,
          disableUpload = _this$props4.disableUpload,
          withPanelNavigator = _this$props4.withPanelNavigator,
          previousSelectedFileId = _this$props4.previousSelectedFileId;

      if (status === _Constants.RequestStatus.SUCCEEDED && total === 0) {
        return _react.default.createElement(_EmptyFolder.default, {
          selectedFolder: selectedFolder,
          folders: folders,
          onCreateFolder: onAddFolder,
          isReadOnly: isReadOnly || disableUpload
        });
      }

      return _react.default.createElement(_FoldersAndFilesContainer.default, {
        type: type,
        tiles: tiles,
        total: total,
        onInsert: onInsert,
        onLoadMoreFiles: this.handleLoadMoreRows,
        disableUpload: disableUpload,
        withPanelNavigator: withPanelNavigator,
        previousSelectedFileId: previousSelectedFileId
      });
    }
  }, {
    key: "renderFolderBreadcrumbs",
    value: function renderFolderBreadcrumbs() {
      var _this$props5 = this.props,
          onClickBreadcrumb = _this$props5.onClickBreadcrumb,
          selectedFolderWithAncestors = _this$props5.selectedFolderWithAncestors;
      return _react.default.createElement(_FolderBreadcrumbs.default, {
        folderWithAncestors: selectedFolderWithAncestors,
        onSelectFolder: onClickBreadcrumb
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          selectedFolder = _this$props6.selectedFolder,
          onSelectFolder = _this$props6.onSelectFolder,
          folders = _this$props6.folders,
          onAddFolder = _this$props6.onAddFolder,
          onBack = _this$props6.onBack,
          type = _this$props6.type,
          filterType = _this$props6.filterType,
          isReadOnly = _this$props6.isReadOnly,
          withPanelNavigator = _this$props6.withPanelNavigator;
      return _react.default.createElement(_UIFlex.default, {
        className: "folder-panel",
        direction: "column"
      }, filterType !== _FileExtensionFilters.default.NONE && _react.default.createElement(_FilterHintMessage.default, {
        drawerType: type
      }), _react.default.createElement(_SearchWithSuggestions.default, {
        type: type
      }), _react.default.createElement(_UIFlex.default, {
        wrap: "wrap",
        className: "folder-panel__toolbar m-top-6 m-bottom-4",
        justify: "between"
      }, !withPanelNavigator ? _react.default.createElement(_UIBackButton.default, null, _react.default.createElement(_UILink.default, {
        onClick: onBack,
        "data-test-id": "browse-back"
      }, _react.default.createElement(_Small.default, null, _I18n.default.text('FileManagerLib.backButton')))) : _react.default.createElement("div", {
        className: "flex-grow-1"
      }), _react.default.createElement("div", null, _react.default.createElement(_BrowseFolders.default, {
        folder: selectedFolder,
        onChangeFolder: onSelectFolder
      }), _react.default.createElement(_AddFolderButton.default, {
        className: "p-y-0 p-right-0 p-left-6",
        folders: folders,
        selectedFolder: selectedFolder,
        onCreate: onAddFolder,
        isReadOnly: isReadOnly
      }, _react.default.createElement(_UIIcon.default, {
        size: 10,
        name: "add"
      }), _react.default.createElement(_Small.default, null, _I18n.default.text('FileManagerLib.addFolderButton'))))), this.renderFolderBreadcrumbs(), _react.default.createElement(_UIBox.default, {
        className: "flex-column",
        grow: 1,
        alignSelf: "stretch"
      }, this.renderTiles()));
    }
  }]);
  return FolderPanel;
}(_react.Component);

FolderPanel.propTypes = {
  type: _propTypes.default.oneOf(Object.keys(_Constants2.DrawerTypes)).isRequired,
  files: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
  tiles: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
  status: _propTypes.default.oneOf(Object.keys(_Constants.RequestStatus)),
  total: _propTypes.default.number.isRequired,
  selectedFolder: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  selectedFolderWithAncestors: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
  folders: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
  fetchFiles: _propTypes.default.func.isRequired,
  onInsert: _propTypes.default.func.isRequired,
  onBack: _propTypes.default.func.isRequired,
  onAddFolder: _propTypes.default.func.isRequired,
  onSelectFolder: _propTypes.default.func.isRequired,
  onClickBreadcrumb: _propTypes.default.func.isRequired,
  filterType: _propTypes.default.oneOf(Object.keys(_FileExtensionFilters.default)).isRequired,
  isReadOnly: _propTypes.default.bool.isRequired,
  disableUpload: _propTypes.default.bool.isRequired,
  withPanelNavigator: _propTypes.default.bool.isRequired,
  previousSelectedFileId: _propTypes.default.number
};

var mapStateToProps = function mapStateToProps(state, props) {
  var folders = (0, _Folders2.getChildFolders)(state);
  var files = (0, _Files.getFiles)(state);
  var tiles = (0, _Tiles.getTiles)(state, props);
  return {
    files: files,
    status: (0, _Files.getFetchFilesRequestStatus)(state),
    selectedFolder: (0, _Panel.getSelectedFolderInPanel)(state),
    selectedFolderWithAncestors: (0, _Panel.getSelectedFolderWithAncestors)(state),
    total: (0, _Tiles2.getTotalFilteredTiles)({
      savedFilesCount: (0, _Files.getFilesTotal)(state),
      files: files,
      tiles: tiles
    }),
    folders: folders,
    tiles: tiles,
    filterType: (0, _Filter.getFilterType)(state),
    isReadOnly: (0, _Permissions.getIsReadOnly)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onSelectFolder: function onSelectFolder(folder) {
      dispatch((0, _Actions.browseToFolder)(folder.get('id')));
      dispatch((0, _Actions.trackInteraction)('fileManagerExploreFiles', 'click-folder', {
        target: 'browse-all-folders'
      }));
    },
    onClickBreadcrumb: function onClickBreadcrumb(folder) {
      dispatch((0, _Actions.browseToFolder)(folder.get('id')));
      dispatch((0, _Actions.trackInteraction)('fileManagerExploreFiles', 'click-folder', {
        target: 'folder-breadcrumbs'
      }));
    },
    onBack: function onBack() {
      dispatch((0, _Actions.goBack)());
    },
    onAddFolder: function onAddFolder(folderName, selectedFolder) {
      dispatch((0, _Folders.addFolder)({
        name: folderName,
        parentId: selectedFolder.get('id') || null
      }));
      dispatch((0, _Actions.trackInteraction)('Manage Files', 'created-new-folder'));
    },
    fetchFiles: function fetchFiles(_ref) {
      var folderId = _ref.folderId,
          initial = _ref.initial,
          type = _ref.type,
          _ref$offset = _ref.offset,
          offset = _ref$offset === void 0 ? 0 : _ref$offset;
      var query = Object.assign({
        limit: _Constants2.DEFAULT_ROWS_TO_FETCH * _Constants2.IMAGE_COLUMN_COUNT,
        folder_id: folderId || 'None',
        offset: offset,
        type: type
      }, (0, _network.getProviderParam)(ownProps.type));

      if (initial) {
        dispatch((0, _Actions.fetchInitialFiles)(query, ownProps.type));
      } else {
        dispatch((0, _Actions.fetchMoreFiles)(query, ownProps.type));
      }
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FolderPanel);

exports.default = _default;
module.exports = exports.default;